// extracted by mini-css-extract-plugin
export var attachment = "_ic-a";
export var emailContainer = "_ic-4";
export var emailContentPaddedContainer = "_ic-b";
export var emailHeader = "_ic-6";
export var emailIframe = "_ic-3";
export var emailInfoIcon = "_ic-9";
export var emailShortenedSummary = "_ic-e";
export var infoDropdown = "_ic-0";
export var infoRowBoundedContent = "_ic-d";
export var internal = "_ic-5";
export var merchant = "_ic-8";
export var messageInputContainer = "_ic-h";
export var normal = "_ic-7";
export var replyCard = "_ic-f";
export var subtleButton = "_ic-1";
export var subtleButtonIconContainer = "_ic-2";
export var toggleViewRepliesButton = "_ic-c";
export var wrappingText = "_ic-g";